import { RowData } from "../s25-spreadsheet/types/sheet.js.types.expanded";
import { SpreadSheetService } from "../s25-spreadsheet/spreadsheet.service";
import { S25Util } from "../../util/s25-util";
import { ImportService, SpecialDateImportSaveResponseDto } from "./import.service";
import { SpecialDateSpreadsheetUtil } from "./util/special-date/special.date.spreadsheet.util";

export interface SpecialDateImportUiState {
    errors: string[];
    successMessage: string;
}

export async function downloadSpecialDateImportTemplate(): Promise<void> {
    await SpreadSheetService.downloadExcel(
        [SpecialDateSpreadsheetUtil.templateRow()],
        "Special_Dates_Import_Template.xlsx",
        "Special Dates Import Template",
    );
}

export async function runSpecialDateImport(rows: RowData[], state: SpecialDateImportUiState): Promise<void> {
    state.errors = [];
    state.successMessage = "";

    if (!rows?.length) {
        state.errors.push("No sheet data found");
        return;
    }

    const errorSet = new Set<string>();
    const dates = SpecialDateSpreadsheetUtil.rowsToSpecialDates(rows, errorSet);
    if (errorSet.size) {
        state.errors = Array.from(errorSet);
        return;
    }
    if (!dates.length) {
        state.errors.push("No valid special date rows found.");
        return;
    }

    try {
        const response = await ImportService.importSpecialDates({ dates });
        applyImportResponse(state, response);
    } catch (caughtError) {
        const errorData = caughtError?.data || caughtError?.error;
        if (errorData?.error) {
            state.errors.push(errorData.error);
        } else {
            S25Util.showError(caughtError, "Failed to import special dates");
        }
    }
}

function applyImportResponse(
    state: SpecialDateImportUiState,
    response: SpecialDateImportSaveResponseDto | undefined,
): void {
    if (response?.error && response.error !== "no_dates") {
        state.errors.push("Error importing special dates: " + response.error);
    }
    if (response?.rowErrors?.length) {
        state.errors.push(...response.rowErrors);
    }
    if (!state.errors.length) {
        state.successMessage = buildSuccessMessage(response);
    } else if (response?.created || response?.updated) {
        state.successMessage = buildSuccessMessage(response);
    }
}

function buildSuccessMessage(response: SpecialDateImportSaveResponseDto | undefined): string {
    const created = response?.created ?? 0;
    const updated = response?.updated ?? 0;
    const skipped = response?.skipped ?? 0;
    return `Imported special dates (${created} created, ${updated} updated, ${skipped} skipped)`;
}
